'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, createContext, useContext } from 'react';
import { EarlyPreviewBanner } from '@/components/EarlyPreviewBanner';
const BANNER_DISMISSED_KEY = 'sizzle-early-preview-banner-dismissed';
interface EarlyPreviewContextValue {
  isVisible: boolean;
  dismiss: () => void;
}
const EarlyPreviewContext = createContext<EarlyPreviewContextValue>({
  isVisible: false,
  dismiss: () => {}
});

/** Returns true when the early-preview banner is visible */
export function useEarlyPreviewBanner() {
  return useContext(EarlyPreviewContext).isVisible;
}
export function useEarlyPreviewDismiss() {
  return useContext(EarlyPreviewContext).dismiss;
}
export function EarlyPreviewBannerProvider(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [isDismissed, setIsDismissed] = useState(true);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const dismissed = localStorage.getItem(BANNER_DISMISSED_KEY);
      setIsDismissed(dismissed === "true");
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsDismissed(true);
      localStorage.setItem(BANNER_DISMISSED_KEY, "true");
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const dismiss = t3;
  const isVisible = !isDismissed;
  let t4;
  let t5;
  if ($[3] !== isVisible) {
    t4 = {
      isVisible,
      dismiss
    };
    t5 = isVisible && <EarlyPreviewBanner />;
    $[3] = isVisible;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t4 || $[8] !== t5) {
    t6 = <EarlyPreviewContext.Provider value={t4}>{t5}{children}</EarlyPreviewContext.Provider>;
    $[6] = children;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}